import { render, staticRenderFns } from "./AppCalendarEventCard.vue?vue&type=template&id=56f9ba34&scoped=true&lang=pug&"
import script from "./AppCalendarEventCard.vue?vue&type=script&lang=js&"
export * from "./AppCalendarEventCard.vue?vue&type=script&lang=js&"
import style0 from "./AppCalendarEventCard.vue?vue&type=style&index=0&id=56f9ba34&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f9ba34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56f9ba34')) {
      api.createRecord('56f9ba34', component.options)
    } else {
      api.reload('56f9ba34', component.options)
    }
    module.hot.accept("./AppCalendarEventCard.vue?vue&type=template&id=56f9ba34&scoped=true&lang=pug&", function () {
      api.rerender('56f9ba34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UI/AppCalendarEventCard.vue"
export default component.exports